module.exports = __webpack_public_path__ + "static/media/hat-chef.461226a0.svg";